// extracted by mini-css-extract-plugin
export default {"section":"home_section__THsKA","sectionLeftPadding":"home_sectionLeftPadding__2D8hm","footerSection":"home_footerSection__Dc-rM","wrapper":"home_wrapper__LMdCn"};